export enum LEAD_SOURCE {
  MY = 'freeproduct_my',
  ID = 'freeproduct_id',
}

export enum LOCKED_FEATURE_TYPE {
  EXPIRED = 1,
  FREE_MENU_LEADS = 2,
}

export enum EXTERNAL_URLS {
  TRY_EASYEAT =' https://try.easyeat.ai/easyeat-lite-negative-balance/',
}

export enum PAYMENT_DESCRIPTON {
  NEGATIVE_BALANCE = 'Negative Balance payment',
  SUBSCRIPTION = 'Subscription',
  CURRENT_BALANCE_PAYMENT = 'Current Balance Payment'
}

export enum CLIENT_ID {
  NEGATIVE_BALANCE = 'negative_balance_payment',
  SUBSCRIPTION = 'subscription',
  CURRENT_BALANCE_PAYMENT = 'current_balance_payment'
}

export enum PAYMENT_METHOD {
  ONLINE = 'online',
  CURLEC = 'curlec',
  SETTLEMENT = 'settlement',
  SAVED_CARD = 'saved_card'
}

export enum TALK_EXPERT_FORM_TYPE {
  NEGATIVE_BALANCE = 'negativeBalance',
  SUBSCRIPTION = 'subscription',
}

export enum PAYMENT_STATUS {
  PENDING = 0,
  SUCCESS = 1,
  FAILED = 2,
}
